var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "uxo-list" },
    [
      _vm.hazards.length
        ? [
            _c("div", { staticClass: "column is-full mb-2" }, [
              _c(
                "button",
                {
                  staticClass: "btn w-100 mb-2",
                  on: {
                    click: function($event) {
                      return _vm.showSearchFilters()
                    }
                  }
                },
                [_vm._v("Filter your search")]
              )
            ]),
            _vm._v(" "),
            _vm._l(_vm.hazards, function(hazard) {
              return _c(
                "div",
                {
                  staticClass:
                    "column is-4-mobile is-4-tablet is-3-desktop mb-2 mb-md-4"
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "uxo-list__item",
                      attrs: { href: _vm.hazardUrl(hazard) }
                    },
                    [
                      hazard.images.length > 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "uxo-list__item-image-placeholder border-radius",
                              style: {
                                "background-image":
                                  "url('" + hazard.images[0].aws_url + "')"
                              }
                            },
                            [
                              _c("img", {
                                staticClass: "image mb-1 d-hidden",
                                attrs: {
                                  src: hazard.images[0]
                                    ? hazard.images[0].aws_url
                                    : "",
                                  alt: hazard.name
                                }
                              })
                            ]
                          )
                        : _c("div", {
                            staticClass:
                              "uxo-list__item-image-placeholder border-radius"
                          }),
                      _vm._v(" "),
                      _c("h5", { staticClass: "uxo-list__item-title" }, [
                        _vm._v(_vm._s(hazard.name))
                      ])
                    ]
                  )
                ]
              )
            })
          ]
        : [
            _c(
              "div",
              { staticClass: "empty-search column text-center py-4 py-md-10" },
              [
                _c("h1", { staticClass: "empty-search__title mb-3" }, [
                  _vm._v(
                    "Unfortunately, there are not any results matching your\n                criteria"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "empty-search__text mb-3" }, [
                  _vm._v(
                    "\n                Try again and make your search less specific\n            "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mb-2 d-md-none" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn w-100",
                      on: {
                        click: function($event) {
                          return _vm.showSearchFilters()
                        }
                      }
                    },
                    [_vm._v("Filter your search")]
                  )
                ])
              ]
            )
          ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f7fb8e8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f7fb8e8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/uxo/List.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4f7fb8e8","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/uxo/List.vue
// module chunks = 0 1